export interface WSVoicemail {
  action: string;
  model: Voicemail;
}

export interface Voicemail {
  id: string;
  label: string;
  tel: string;
  transcription: unknown;
  filename: string;
  type: VoicemailType;
  forwarded: string | null;
  contactId?: string;
  duration: number;
  dateTime: string;
  shared_uuid?: string | null; // this is purely for WSVoicemail
  sharedInfo?: SharedVoicemail; // for shared voicemails
}

export enum VoicemailType {
  RecentlyDeleted = 'trash',
  Voicemail = 'vmail/new',
  VoicemailSaved = 'vmail/save',
}

/**
 * Read-state is encoded in `type` on the wire: `vmail/new` is unread, everything else
 * (saved or trash) is considered read.
 */
export function isVoicemailRead(vm: Voicemail): boolean {
  return vm.type !== VoicemailType.Voicemail;
}

export interface VoicemailNumber {
  number: string;
  shared?: boolean;
  uuid?: string;
  description?: string;
}

export const AllVoicemailNumber: VoicemailNumber = {
  number: 'all',
};

export interface SharedVoicemail {
  user: string;
  access: 'write' | 'read';
  aor: string;
  uuid: string;
  name: string | null;
}

export interface ShareVoicemail {
  id: string;
  label: string;
  tel: string;
  dateTime: string;
  contactId?: string;
  transcription?: unknown;
  mediaUrl?: string;
  forwarded?: string | null;
}
